module.exports = __webpack_public_path__ + "img/25mart.36fa6d80.png";